import styled from "styled-components";
import colors from "../../../../../../config/colors";

export const CountBarContainer = styled.div`
`;
export const BarBox = styled.div`
  display: flex;
`;
export const FilledBox = styled.div`
  background-color: ${colors.primary};
  min-width: ${(props) => props.width}%;
  width: ${(props) => props.width}%;
  color: ${colors.background};
  padding: 0px 0px;
  box-sizing:border-box;
  text-align: right;
`;
export const EmptyBox = styled.div`
  background-color: ${colors.darkBackground};
  min-width: ${(props) => props.width}%;
  padding: 0px 0px;
  box-sizing:border-box;
`;
export const TextContainer=styled.div`
    padding:0px 5px;

`;